<template>
  <div
    class="circle-container"
    :style="{
      width: size,
      height: size,
      backgroundColor,
      color,
      border: `1px ${borderColor} solid`,
    }"
  >
    <!-- Slot for child content (image or component) -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CircleCenter",
  props: {
    size: {
      type: String,
      default: "150px",
    },
    backgroundColor: {
      type: String,
      default: "transparent",
    },
    color: {
      type: String,
      default: "white",
    },
    borderColor: {
      type: String,
      default: "white",
    },
  },
};
</script>

<style scoped>
.circle-container {
  border-radius: 50%; /* Makes the div a circle */
  background-color: #eee; /* Just for visibility */
  display: flex; /* Enables flexbox */
  align-items: center; /* Vertically center */
  justify-content: center; /* Horizontally center */
  overflow: hidden;
}

img {
  width: 80%;
  height: auto;
  object-fit: cover;
}
</style>
